import axios from 'axios';
import config from '../config';

const GetAll = async (page, count, keyword) => {
    try {
        const token = localStorage.getItem("oojwt");
        const response = await axios.get(`${config.apiUrl}country/all?page=${page}&resultCount=${count}&keyword=${keyword}`,
            {
                headers: {
                    'Authorization': 'Bearer ' + token
                }
            });
        if (response.status === 200) {
            console.log("countrys", response.data);
            return {
                status: 200,
                countrys: response.data.countrys,
                total: response.data.pagination.totalResults,
                totalPages: response.data.pagination.totalPages
            };
        }
    } catch (error) {
        console.log(error);
        return {
            status: 401,
            message: error.response.data.message
        };
    }
}


// get by id
const GetById = async (id) => {
    try {
        const token = localStorage.getItem("oojwt");
        const response = await axios.get(`${config.apiUrl}country/get-by-id?id=${id}`, {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });
        
        if (response.status === 200) {
            return {
                status: 200,
                country: response.data.country
            };
        }
    } catch (error) {
        console.log(error);
        return {
            status: 404,
            message: error.response.data.message
        };
    }
}


//add country
const Add = async (name) => {
    try {
        const data = new FormData();
        data.append("name", name);
        console.log(data);
        const token = localStorage.getItem("oojwt");
        const response = await axios.post(config.apiUrl + 'country/add', data, {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });
        if (response.status === 201) {
            return {
                status: 200,
                message: response.data.message,
                country: response.data.country
            };
        }
    } catch (error) {
        console.log(error);
        return {
            status: 400,
            message: error.response.data.message
        };

    }
}

//update country
const Update = async (id, name, status) => {
    try {
        const data = new FormData();
        data.append("id", id);
        data.append("name", name);
        data.append("status", status);
        
        const token = localStorage.getItem("oojwt");
        const response = await axios.post(`${config.apiUrl}country/update`, data, {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });
        
        if (response.status === 200) {
            return {
                status: 200,
                message: response.data.message,
                country: response.data.country
            };
        }
    } catch (error) {
        console.log(error);
        return {
            status: 400, 
            message: error.response.data.message
        };
    }
}


export { GetAll, Add, Update, GetById };

